"use strict";
// import "@rmlibrary/fetch";
//import { param } from "jquery";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoData = void 0;
var clipsToReset = [];
function buildTimeline() {
    return [
        //Q1
        "scotia-intro-image",
        "scotia-intro",
        "scotia-q1",
        //Goals
        "scotia-goal-legacy",
        "scotia-goal-home",
        "scotia-goal-travel",
        "scotia-goal-children",
        "scotia-goal-expand-business",
        "scotia-goal-lifestyle",
        "scotia-goal-parents",
        "scotia-goal-start-business",
        "scotia-goal-succession",
        "scotia-goal-nest",
        //Q2
        "scotia-pre-q2",
        "scotia-q2",
        //Q2 choices
        "scotia-q2-choice-1",
        "scotia-q2-choice-2",
        "scotia-q2-choice-3",
        "scotia-q2-choice-4",
        //Q3
        "scotia-q3",
        //Q3 choices
        "scotia-q3-choice-1",
        "scotia-q3-choice-2",
        "scotia-q3-choice-3",
        "scotia-q3-choice-4",
        //outro
        "scotia-outro",
        "scotia-outro-image"
    ];
}
function getVideoData() {
    var timeline = buildTimeline();
    return { clipsToReset: clipsToReset, timeline: timeline };
}
exports.getVideoData = getVideoData;
//# sourceMappingURL=module.js.map